
import ModalView from 'common-views/ModalView';
import template  from 'dashboard/forms/modal/recover-design-modal.ejs';
import constants from 'Constants';
import restService from 'RestService';
import Spinner from 'spin/spin';
import listService from 'ListService';

class RecoverDesignModal extends ModalView {

    initialize(){
        super.initialize();
        this.template = template;
        this.model.set("view", listService.docType === constants.DOC_TYPE_REPORT ? "report" : "app", {silent: true});
        const type = listService.docType === constants.DOC_TYPE_REPORT ? "Report" : "App";
        this.model.set("title", this.model.get("fromAction") === "design" ? "Recover Design" : "Publish " + type, {silent: true});
    }
    
    render(){
        const formId = this.model.get("formId");
        const fromAction = this.model.get("fromAction");
        const view = this.model.get("view");

        const message = "Select Recover Design to open the " + view 
                                                    + " version with the recovered changes from " + this.model.get("recoverDate")
                                                    + " (UTC). This action will create a new " + view 
                                                    + " version, but the last properly saved version will still be available." 

        const messageDiscard = fromAction === "design" ? "Select Discard to open the " + view + 
                                                        " version that was properly saved on "+ this.model.get("lastUpdate") + " (UTC), which will discard the recovered changes." : 
                                                        "Select Publish to remove the recovered changes and continue publishing your " + view + " that was properly saved on " + this.model.get("lastUpdate") + " (UTC).";
        
        this.model.set("message", message, {silent:true});
        this.model.set("messageDiscard", messageDiscard, {silent:true});

        const height = fromAction === "design" ? view === "form" ? 250 : 270 : 265;
        
        return new Promise((resolve, reject) => {
            const settings = this.settings;
            settings.height = height;
            settings.width = 525;

            settings.buttons = [
                {
                    text: 'Recover Design',
                    click: () => {                      
                        resolve("recover")
                        this.closeModal();
                    }
                },
                {
                    text: fromAction === "design" ? 'Discard' : "Publish",
                    click: () => {
                        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                        restService.closeForm(formId).then((data) => {

                            resolve(fromAction === "design" ? "openForm" : "publish");
                            spinner.stop();
                            this.closeModal();
                        });
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        resolve('cancel');
                        this.closeModal();
                    }
                }
            ];

            settings.open = () => {
            
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }
}

export default RecoverDesignModal;